var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notfound"},[_c('div',{staticClass:"container view col center middle"},[_c('h1',{staticClass:"notfound__title"},[_c('span',{staticClass:"notfound__code"},[_vm._v("404 -")]),_vm._v(" "+_vm._s(_vm.$t('notfoundTitle')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }